<template>
	<div class="pageSetting-body">
		<div class="fx-header">
			<p>页面装修</p>
		</div>
		<div class="body-box">
      <div class="tabs-box">
        <el-tabs v-model="activeName" @tab-click="tabsHandleClick">
          <el-tab-pane label="采购" name="first">
						<div class="first-box">
							<div class="input-box">
								<span>页面名称：</span>
								<el-input
									class="search-input"
									v-model="pageName"
									placeholder="请输入页面名称"
									size="small"
									@keyup.enter.native="search">
								</el-input>
								<el-button type="primary" size="mini" class="btn" @click="search">查询</el-button>
							</div>
							<MainTable
								:size='size'
								:page='page'
								:tableData='tableData'
								:totalCount='totalCount'
								:AuthorityList='AuthorityList'
								@handleSize='handleSizeChange'
								@handlePage='handlePageChange'
							/>
						</div>
					</el-tab-pane>
        </el-tabs>
      </div>
		</div>
	</div>
</template>
<script>
import MainTable from '@/components/pageSetting/MainTable.vue'
export default {
	name: 'pageSetting',
	components: {
		MainTable
	},
	data () {
		return {
			activeName: 'first',
			pageName: '',
			page: 1,
			size: 20,
			totalCount: 0,
			tableData: [],
			AuthorityList: {
				'16_0001_0001_00': false
			}
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '15-1')
		this.getAuthority('16_0001_0000_00')
		this.getList()
	},
	mounted () {

	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		tabsHandleClick (tab, event)	{
			console.log(tab.name)
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.getList()
		},
		handlePageChange (value) {
			this.page = value
			this.getList()
		},
		getList () {
			let params = {
				styleName: this.pageName,
				styleType: 1,
				page: this.page,
				size: this.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/style/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.totalCount = res.recordCount
			})
		},
		search () {
			this.getList()
		}
	}
}
</script>

<style lang="stylus" scoped>
.pageSetting-body{
	flex: 1
	display flex
	flex-direction column
	.body-box{
		width :100%;
		padding-bottom :10px
		.tabs-box {
			font-size: 16px
			.first-box {
				font-size: 14px;
				.input-box {
					display: flex
					align-items: center;
					padding: 30px 0;
				}
				.el-input {
					width: 200px
				}
				.btn {
					margin-left: 5px
				}
			}
		}
	}
}

</style>
<style lang="stylus">

</style>

